<template>
  <div class="resultPage">
    <navigate-header hasBack="true" :title="navigateTitle" v-if="hasHeader" :navigateStyle="navigateStyle">
      <div slot="rightBtn" class="btn right-btn" color-primary @click="goNext">
        完成
      </div>
    </navigate-header>
    <section class="page-content">
      <p class="icon">
        <i class="iconfont etc-icon-check" color-primary></i>
      </p>
      <header color-primary>提交成功</header>
      <p class="tip">{{resultContent.tip}}</p>
      <div class="btn-wrap">
        <button cool-btn @click="goNext" v-if="resultContent.btn">{{resultContent.btn}}</button>
      </div>
    </section>
    <section class="page-bottom"></section>
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
// components
import NavigateHeader from '@/components/cool.navigateHeader'

const CONTENT = {
  optionBank: {
    tip: '已经收到你的反馈，银行上线会第一时间通知您，感谢你的参与',
    btn: '知道了'
  }
}
export default {
  name: 'result',
  mixins: [FunMixin],
  components: {
    NavigateHeader
  },
  data() {
    return {
      resultContent: ''
    }
  },
  computed: {},
  methods: {
    goNext() {
      this.$router.back()
    }
  },
  mounted() {
    this.resultContent = CONTENT[this.$route.query.type] || ''
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";

.resultPage {
  .page-content {
    background-color: #fff;
    text-align: center;
    .icon{
      padding-top: 100px;
      text-align: center;
      i{
        font-size: 200px;
      }
    }
    header{
      font-size: 40px;
      font-weight: bold;
      margin-top: 50px;
    }
    .tip{
      margin-top: 30px;
      font-size: 28px;
      color: #999999;
      padding: 0 65px;
    }
    .btn-wrap{
      padding: 60px 55px;
    }
  }
  .page-bottom {
  }
}
</style>
